import { inject, Injectable } from "@angular/core";
import { CategoryV5, OrderParamsV5, SetTradingStopParamsV5, WS_KEY_MAP } from "libs/bybit-api/src";
import { catchError, forkJoin, from } from "rxjs";
import { MarketError } from "src/app/core/error/codes";
import { BybitRestClient, BybitWebsocketClient } from "src/app/core/market";
import { CreateOrderParams, CreateStopOrderParams, Order, OrderSide, OrderType, PositionSide } from "src/app/core/model/trade";
import { OrderHelper } from "../../order.helper";

@Injectable({
  providedIn: 'root'
})
export class BybitOrderManager {

  private orderHelper = inject(OrderHelper)

  private throwMarketError(e: any): never {
    if (e.retCode && e.retMsg) {
      throw new MarketError(e.retCode, e.retMsg, e.data)
    }
    throw e
  }

  createOrder(ws: BybitWebsocketClient, order: CreateOrderParams) {
    const params: OrderParamsV5 = {
      orderLinkId: this.orderHelper.generateClientOrderId(order.market),
      category: order.board as CategoryV5,
      symbol: order.symbol,
      orderType: order.type == OrderType.market ? 'Market' : 'Limit',
      side: order.side == OrderSide.buy ? 'Buy' : 'Sell',
      qty: order.quantity.toString(),
    }
    if (order.price !== undefined) {
      params.price = order.price.toString()
    }
    if (order.positionSide !== undefined) {
      params.positionIdx = order.positionSide == PositionSide.both ? 0 : order.positionSide == PositionSide.long ? 1 : 2
    }
    if (order.closePosition === true) {
      params.reduceOnly = true
    }
    return from(ws.sendWSAPIRequest(WS_KEY_MAP.v5PrivateTrade, 'order.create', params)).pipe(
      catchError(e => this.throwMarketError(e))
    )
  }

  createStopOrder(rest: BybitRestClient, order: CreateStopOrderParams) {
    const params: SetTradingStopParamsV5 = {
      category: order.board as CategoryV5,
      symbol: order.symbol,
      tpslMode: 'Full',
      positionIdx: order.positionSide == undefined || order.positionSide == PositionSide.both ? 0 : order.positionSide == PositionSide.long ? 1 : 2,
      stopLoss: order.triggerPrice.toString(),
    }
    return from(rest.setTradingStop(params))

    /*const params: OrderParamsV5 = {
      orderLinkId: this.orderHelper.generateClientOrderId(order.market),
      category: order.board as CategoryV5,
      symbol: order.symbol,
      orderType: order.type == OrderType.market ? 'Market' : 'Limit',
      side: order.side == OrderSide.buy ? 'Buy' : 'Sell',
      qty: '0',
      triggerDirection: order.triggerDirection == 'rise' ? 1 : 2,
      triggerPrice: order.triggerPrice.toString(),
    }
    if (order.quantity !== undefined) {
      params.qty = order.quantity.toString()
    }
    if (order.price !== undefined) {
      params.price = order.price.toString()
    }
    if (order.positionSide !== undefined) {
      params.positionIdx = order.positionSide == PositionSide.both ? 0 : order.positionSide == PositionSide.long ? 1 : 2
    }
    if (order.closePosition === true) {
      params.reduceOnly = true
      params.closeOnTrigger = true
    }
    return from(ws.sendWSAPIRequest(WS_KEY_MAP.v5PrivateTrade, 'order.create', params)).pipe(
      catchError(e => this.handleError(e))
    )*/
  }

  cancelOrder(ws: BybitWebsocketClient, order: Order) {
    return from(ws.sendWSAPIRequest(WS_KEY_MAP.v5PrivateTrade, 'order.cancel', {
      category: order.board as CategoryV5,
      symbol: order.symbol,
      orderId: order.orderId.toString(),
    })).pipe(
      catchError(e => this.throwMarketError(e))
    )
  }

  cancelOrders(ws: BybitWebsocketClient, orders: Order[]) {
    return forkJoin(orders.map(order => this.cancelOrder(ws, order)))
  }

}
